import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const changeDocDeadlineDate = async ({ docId, deadlineDate }) => {
  return await request.put(
    `/Docs/deadline_date/${docId}?deadlineDate=${deadlineDate}`,
    null,
    'При изменении срока ответа документа произошла ошибка',
    'Error'
  );
};

const useChangeDeadlineDate = () => {
  const mutation = useMutation(changeDocDeadlineDate, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

  return {
    isLoadingDocDeadlineDate: mutation.isLoading,
    changeDocDeadlineDate: mutation.mutateAsync,
  };
};
export default useChangeDeadlineDate;
